import React from 'react';
import { Col, Container, Modal, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import WaitingContactTable from '../components/WaitingContactTable';
import type { WaitingContact } from '../types/Contact';

const i18nPrefix = 'ContactTable';

type Props = {
  showModal: boolean;
  hideModal: () => void;
  onSelectContact: (contact: WaitingContact) => void;
};
const WaitingContactListModal = ({
  showModal,
  hideModal,
  onSelectContact,
}: Props) => {
  const { t: translate } = useTranslation();

  const onRowDoubleClick = (contact: WaitingContact, arg2: unknown) => {
    console.log('onRowDoubleClick: ', contact, arg2);
    onSelectContact(contact);
  };

  return (
    <Modal animation={false} size='xl' show={showModal} onHide={hideModal}>
      <Modal.Header closeButton>
        <Modal.Title>{translate(`${i18nPrefix}.selectContact`)}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container style={{ maxHeight: 'none', backgroundColor: 'white' }}>
          <Row>
            <Col sm={4}>
              <h1>{'Warteliste'}</h1>
              <h2>{'Auswählen '}</h2>
            </Col>
          </Row>

          <WaitingContactTable onRowDoubleClick={onRowDoubleClick} />
        </Container>
      </Modal.Body>
    </Modal>
  );
};

export default WaitingContactListModal;
